import {Routes} from '@angular/router';
import { permissions } from './permissions';

import {SignupComponent} from './auth/signup/signup.component';
import {NgxPermissionsGuard} from 'ngx-permissions';

import {AuthGuardService as AuthGuard} from './auth-guard.service';

export const routes: Routes = [{
    path: '',
    canActivate: [AuthGuard],
    data: {
        title: 'Home'
    },
    children: [{
        path: 'dashboard',
        loadChildren: './views/dashboard/dashboard.module#DashboardModule',
        canActivate: [NgxPermissionsGuard],
        data: {
            permissions: {
                only: [permissions.DASHBOARD_READ]
            }
        }
    }, {
        path: 'userlog',
        loadChildren: './views/userlog/userlog.module#UserlogModule',
        canActivate: [NgxPermissionsGuard],
        data: {
            permissions: {
                only: []
            }
        }
    }]
}, {
    path: 'signup',
    component: SignupComponent
}];



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/app.routing.ts